export default __webpack_public_path__ + "static/media/icon-voucher.44899381.svg";